import { useEffect, useState, useContext, useRef } from "react";
import ErrorComponent from "./Error";

import Dialog from "./Dialog";
import ErrorUtils from '../utils/ErrorUtils';

import LanguageContext from "../contexts/Language";
import TitleContext from "../contexts/Title";
import UtilContext from "../contexts/Util";
import StatusContext from "../contexts/Status";
import UserDataContext from "../contexts/UserData";

import AppConfig from "../AppConfig";

export default function Login({ disableAcceptBtn, login, socialLogin, config, client_conns, view_disabled, redirectToPasswordReset, default_phone_region, loockupPhoneNo }) {
  // ===========================================================
  // React Variables
  // ===========================================================
  // -----------------------------
  // Context
  // -----------------------------
  const { getTag, lang, tags } = useContext(LanguageContext);
  const { email_is_valid } = useContext(UtilContext);
  const { setTitle, header_title } = useContext(TitleContext);
  const { setPageStatus } = useContext(StatusContext);
  const { user_data } = useContext(UserDataContext);
  // -------------------------------
  // State
  // -----------------------------
  const [occuredError, setOccuredError] = useState(false);
  const [inputError, setInputError] = useState("");
  const [processing, setProcessing] = useState(false);
  const [email, setEmail] = useState("");
  const [phone_cd, setPhoneCd] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [inactiveEmail, setInactiveEmail] = useState("inactive");
  const [inactivePhone, setInactivePhone] = useState("inactive");
  const [loginIdType, setloginIdType] = useState("");
  // -----------------------------
  // Ref
  // -----------------------------
  const errorData = useRef(null);
  const regionRef = useRef("");
  const phoneRef = useRef("");

  // ===========================================================
  // Base Difinitions
  // ===========================================================
  // ----------------------------------------------------------
  // Event Listeners
  // ----------------------------------------------------------
  // 画面遷移時の処理
  // エラー状態をリセットし、ダイアログが開いている場合はそれを閉じる
  window.addEventListener('popstate', function (e) {
    closeDialog();
  });

  // ===========================================================
  // Methods
  // ===========================================================
  /***************************
   * ダイアログを閉じる処理
   * 
   * エラー状態をリセットし、ダイアログを閉じる
   ***************************/
  const closeDialog = () => {
    setOccuredError(false);
    errorData.current = null;
    Dialog(false);
  }

  /***************************
   * 電話番号入力検証
   * 
   * 問題なければ true
   * 問題がある場合、エラーリソースID
   ***************************/
  const validPhone = (in_phone) => {
    // 入力チェック
    if (!in_phone) {
      return "empty_phone";
    }

    // フォーマット検証
    let phoneno = regionRef.current.replace("+", "") + in_phone;
    if (!(/^[0-9]+$/.test(phoneno))) {
      return "invalid_phone";
    }

    if (phoneno.length < 8 || 15 < phoneno.length) {
      return "invalid_phone";
    }
    return true;
  }

  /***************************
   * ログインID種別生成
   * 
   * 問題なければ 生成したReactDOM
   * 問題がある場合 null
   ***************************/
  const createLoginIdTypeElements = () => {
    let addLoginIDType = null;
    if (!view_disabled.disabledLoginIDType) {
      let email = getTag("login.type_email") ?? "メールアドレス（仮）";
      let phone = getTag("login.type_phone") ?? "電話番号（仮）";
      let checkedEmail = user_data.login_id_type === "email" ? "checked" : "";
      let checkedPhone = user_data.login_id_type === "phone" ? "checked" : "";
      addLoginIDType = [];
      addLoginIDType.push(
        <div id="LoginIDType" key="LoginIDType">
          <div>
            <input id="LoginIDTypeEmail" name="LoginIDTypeSelector" className="radio" type="radio" value="Email" onChange={onChangeLoginIDType} defaultChecked={checkedEmail} />
            <label className="radio_label" htmlFor="LoginIDTypeEmail">{email}</label>
          </div>
          <div>
            <input id="LoginIDTypePhone" name="LoginIDTypeSelector" className="radio" type="radio" value="Phone" onChange={onChangeLoginIDType} defaultChecked={checkedPhone} />
            <label className="radio_label" htmlFor="LoginIDTypePhone">{phone}</label>
          </div>
        </div>
      );
    }
    return addLoginIDType;
  }

  /***************************
   * ソーシャルエリアの生成
   * 
   * 問題なければ 生成したReactDOM
   * 問題がある場合 null
   ***************************/
  const createSocialAreaElements = () => {
    let addSocialItems = [];
    if (!view_disabled.disabledSocial && client_conns !== undefined && client_conns !== null) {
      let tmpItems = [];
      for (let conn of client_conns) {
        let name = conn['name'];
        let cName = "social_" + name;
        let tag = "login.social." + name;
        let text = getTag(tag);
        if (text != null && text.length > 0) {
          tmpItems.push(<div id={name} key={cName} onClick={(ev) => handleSocialSubmit(ev)}><span key={tag} className={"icon-" + name + " social-button-" + name + " social-button-icon social_btn " + cName}>{text}</span></div>);
        }
      }
      if (tmpItems.length > 0) {
        let text = getTag("register.social_separator");
        addSocialItems.push(<div id="SocialArea" key="SocialArea" className="social " data-separator={text}>{tmpItems}</div>);
      }
    }
    return addSocialItems;
  }

  // ===========================================================
  // Actions
  // ===========================================================
  // ----------------------------------------------------------
  // Event Triggers
  // ----------------------------------------------------------
  /***************************
   * ログインID種別
   ***************************/
  const onChangeLoginIDType = (ev) => {
    let elm = ev.currentTarget;
    let target = elm.value;
    document.querySelector("#LoginIDTypeInputEmail").classList.add("inactive");
    document.querySelector("#LoginIDTypeInputPhone").classList.add("inactive");
    document.querySelector("#LoginIDTypeInput" + target).classList.remove("inactive");
    setloginIdType(target.toLowerCase());
    user_data["login_id_type"] = target.toLowerCase();
    setPassword("");
    setInputError("");
  }

  /***************************
   * メールアドレス欄
   ***************************/
  const onChangeEmail = (ev) => {
    let em = ev.target.value;
    setEmail(em);
  };
  const onBlurEmail = (ev) => {
    let em = ev.target.value;
    setEmail(em);

    if (em.length <= 0) {
      setInputError("empty_email");
    }
    else if (!email_is_valid(em)) {
      setInputError("invalid_email");
    }
    else {
      setInputError("")
    }
  };

  /***************************
   * 国・地域欄
   ***************************/
  const onChangeRegion = (ev) => {
    const target = ev.target.options[ev.target.selectedIndex];
    let region = target.dataset.phoneno;
    regionRef.current = region;
    setPhoneCd(target.value);
  };
  const onBlurRegion = (ev) => {
    if (!regionRef.current) {
      setInputError("empty_region");
    }
    else {
      setInputError("");
    }
  }

  /***************************
   * 電話番号欄
   ***************************/
  const onChangePhone = (ev) => {
    let val = ev.target.value.replace(/[^0-9]/g, "");
    ev.target.value = val;
    phoneRef.current = val;
  };

  const onBlurPhone = (ev) => {
    phoneRef.current = ev.target.value;
    let res = validPhone(ev.target.value);
    if (res === true) {
      res = "";
    }
    setInputError(res);
  };

  /***************************
   * パスワード欄
   ***************************/
  const onChangePassword = (ev) => {
    const newpass = ev.target.value;
    setPassword(newpass);
  };
  const onBlurPassword = (ev) => {
    if (ev.target.value.length <= 0) {
      setInputError("empty_password");
    }
    else {
      setInputError("");
    }
  }

  /***************************
   * パスワード表示欄
   ***************************/
  const onChangePasswordShown = (ev) => {
    const passwordShown = ev.target.checked;
    setPasswordShown(passwordShown);
  };

  const passwordInputType = (ev) => {
    if (passwordShown) {
      return 'text';
    } else {
      return 'password';
    }
  };

  /***************************
   * ログインボタン
   ***************************/
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setProcessing(true);

    let username = email;
    localStorage.setItem('Email', email);
    if (loginIdType === "phone") {
      username = regionRef.current + phoneRef.current;
      try {
        username = await loockupPhoneNo(username);
      }
      catch (err) {
        console.log(err.message);
        let errdata = ErrorUtils.getErrorInfo(err);
        setInputError(errdata.code);

        // コントロール活性
        setProcessing(false);
        return;
      }
      localStorage.setItem('phone_cd', phone_cd);
      localStorage.setItem('phone', phoneRef.current);
    }
    login(username, password, setOccuredError, errorData, setInputError, () => { setProcessing(false) }, loginIdType);
  };

  /***************************
   * ソーシャルボタン
   ***************************/
  const handleSocialSubmit = async (ev) => {
    ev.preventDefault();
    setProcessing(true);

    socialLogin(ev.currentTarget.id);
  }

  /***************************
   * ログインボタン有効判定処理
   ***************************/
  const canSubmit = () => {
    let res = false;
    if (loginIdType === "phone") {
      res = password && regionRef.current && phoneRef.current && !processing;
      if (res) {
        res = validPhone(phoneRef.current) === true ? true : false;
      }
    }
    else {
      res = password && email_is_valid(email) && !processing;
    }
    disableAcceptBtn("Login", !res);
    return res;
  };

  /***************************
   * 他画面遷移処理
   ***************************/
  const transLink = (in_target) => {
    user_data["phone_cd"] = phone_cd;
    user_data["phone_region"] = regionRef.current;
    setRedirect(in_target);
  };

  /***************************
   * FAQからの復帰先URL生成
   ***************************/
  const getReturnToUrl = () => {
    const query = new URLSearchParams(window.location.search);
    query.delete("first");
    const queryString = query.toString();
    const returnToUrl = `${window.location.protocol}//${window.location.host}/login?${queryString}`;
    return returnToUrl;
  };

  // ----------------------------------------------------------
  // useEffect
  // ----------------------------------------------------------
  /***************************
   * 初期処理（初回のみ）
   ***************************/
  useEffect(() => {
    var Email = localStorage.getItem('Email');
    if (Email === "undefined") {
      localStorage.setItem("Email", "");
      setEmail("");
    }
    else if (Email) {
      setEmail(Email);
    }

    var phone_cd = localStorage.getItem('phone_cd');
    if (phone_cd === "undefined") {
      localStorage.setItem("phone_cd", "");
      setPhoneCd("");
    }
    else if (phone_cd) {
      setPhoneCd(phone_cd);
    }

    var phone = localStorage.getItem('phone');
    if (phone === "undefined") {
      localStorage.setItem("phone", "");
      phoneRef.current = "";
    }
    else if (phone) {
      phoneRef.current = phone;
    }
  }, []);

  /***************************
   * 画面表示初期処理
   ***************************/
  useEffect(() => {
    if (user_data.login_id_type) {
      setInactiveEmail(user_data.login_id_type === "email" ? "" : "inactive");
      setInactivePhone(user_data.login_id_type === "phone" ? "" : "inactive");
      setloginIdType(user_data.login_id_type);
    }
    if (user_data.phone_cd) {
      setPhoneCd(user_data.phone_cd);
    }
    setTitle(getTag("login.header_title"));
  }, [user_data, setTitle, header_title, getTag]);

  /***************************
   * エラーダイアログ表示判定
   ***************************/
  useEffect(() => {
    // エラー発生判定
    if (occuredError && errorData.current) {
      // コード期限切れエラーの場合、エラー画面へ遷移するため、ダイアログ表示しない
      if (errorData.current.title !== 'error.not_migrated_title') {
        // エラーダイアログ表示
        Dialog({
          title: getTag(errorData.current.title),
          message: getTag(errorData.current.description),
          buttonLabel: getTag('passwordreset.close'),
          btn_action: closeDialog,
          btn_cancel: closeDialog
        });
      }
    }
  }, [occuredError, getTag]);

  /***************************
   * リダイレクト遷移判定処理
   ***************************/
  useEffect(() => {
    if (redirect) {
      setPageStatus(redirect);
    }
  }, [redirect, setPageStatus]);

  // ===========================================================
  // Build HTML
  // ===========================================================
  // ログインID種別の生成
  let addLoginIDType = createLoginIdTypeElements();

  const tmpRegionsNo = tags[lang].common.regions_no;
  const tmpRegionsLabel = tags[lang].common.regions_label;
  //console.dir(tmpRegionsNo);
  //console.dir(tmpRegionsLabel);

  // -------------------------------
  // デフォルト国番号の判定と生成
  // 1. 国番号と国コードが設定されている場合、マスタに直接存在確認をする
  // 2. 国番号しかない場合、番号のみで存在確認をする
  // -------------------------------  
  //console.dir(default_phone_region);
  let defRegKey = phone_cd ?? null;
  let defRegPre = "phone_no_";
  let defRegNo = null;
  if (default_phone_region && default_phone_region.no) {
    defRegNo = default_phone_region.no
  }
  let defRegCountry = null;
  if (default_phone_region && default_phone_region.country) {
    defRegCountry = default_phone_region.country.toUpperCase();
  }
  //console.log(defRegNo);
  //console.log(defRegCountry);
  if (defRegNo && defRegCountry) {
    defRegKey = defRegPre + defRegCountry + "_" + defRegNo;
    if (!tmpRegionsNo[defRegKey]) {
      defRegKey = "";
    }
  }
  else if (defRegNo && !defRegKey) {
    let res = Object.entries(tmpRegionsNo).find(([key, value]) => key.endsWith("_" + defRegNo));
    //console.log(res);
    if (res) {
      defRegKey = res[0];
    }
  }
  //console.log(defRegKey);
  if (defRegKey && !regionRef.current) {
    //console.log(tmpRegionsNo[defRegKey]);
    regionRef.current = tmpRegionsNo[defRegKey];
    setPhoneCd(defRegKey);
  }

  // -------------------------------
  // 国地域選択ボックスの生成
  // -------------------------------  
  let addRegionItems = [];
  let resId = "register.region_placeholder";
  let text = getTag(resId);
  //console.log(text);
  addRegionItems.push(<option key={resId} className="inactive">{text}</option>);
  if (tmpRegionsNo) {
    for (const [key, value] of Object.entries(tmpRegionsNo)) {
      let label = value;
      if (tmpRegionsLabel && tmpRegionsLabel[key]) {
        label += " " + tmpRegionsLabel[key];
        addRegionItems.push(<option key={key} value={key} data-phoneno={value}>{label}</option>);
      }
    }
  }
  //console.dir(addRegionItems);

  // -------------------------------
  // ソーシャルエリアの生成
  // -------------------------------
  let addSocialItems = createSocialAreaElements();

  // -------------------------------
  // エラー画面構築判定
  // -------------------------------
  if (errorData.current) {
    if (errorData.current.title === "error.not_migrated_title") {
      return <ErrorComponent title={errorData.current.title} error={errorData.current.description} to_button={"passwordreset.continue"} btn_action={() => redirectToPasswordReset(email)} />;
    }
  }

  // -------------------------------
  // 表示画面構築
  // -------------------------------
  return (
    <div id="Login" className="form">
      <div className="input_area">
        <h1 className="title">{getTag("login.title")}</h1>
        <p className="description">{getTag("login.description")}</p>
        <div className="input_area">
          {addLoginIDType}
          <p id="LoginIDTypeInputEmail" className={inactiveEmail}>
            <label htmlFor="email">{getTag("login.id_label")}</label>
            <input type="email" id="email" name="email" placeholder={getTag("login.id_placeholder")} defaultValue={email} onChange={onChangeEmail} onBlur={onBlurEmail} disabled={processing} />
          </p>
          <p id="LoginIDTypeInputPhone" className={inactivePhone}>
            <label htmlFor="regions">{getTag("login.region_title")}</label>
            <select name="regions" value={defRegKey} onChange={(ev) => onChangeRegion(ev)} onBlur={onBlurRegion}>
              {addRegionItems}
            </select>
            <label htmlFor="phone">{getTag("login.phone_label")}</label>
            <input type="tel" id="phone" name="phone" placeholder={getTag("login.phone_placeholder")} defaultValue={phoneRef.current} onChange={onChangePhone} onBlur={onBlurPhone} disabled={processing} maxLength={15} />
          </p>
        </div>
        <p>
          <label htmlFor="password">{getTag("login.pw_label")}</label>
          <input type={passwordInputType()} id="password" name="password" placeholder={getTag("login.pw_placeholder")} value={password} onChange={onChangePassword} onBlur={onBlurPassword} disabled={processing} />
          <input type="checkbox" id="showPassword" onChange={onChangePasswordShown} /><label htmlFor="showPassword" id="showPasswordLabel">{getTag("login.show_password")}</label>
        </p>

      </div>
      {inputError && <div id="Notification" className="error">{getTag("error." + inputError)}</div>}
      <div className="action_area">
        <p className="action_btn"><button className="btn_l acceptbtn disabledbtn" disabled={!canSubmit()} onClick={(ev) => handleSubmit(ev)}>{getTag("login.sign_in")}</button></p>
      </div>
      <div className="linklist">
        {!view_disabled.disabledPwReset && <p><button className="link agreement" onClick={() => transLink("/password/recover")}><span>{getTag("login.forgot_pw") || "Forgot Password ?"}</span></button></p>}
        {!view_disabled.disabledSignup && <p><button className="link agreement" onClick={() => transLink("/register/form")}><span>{getTag("login.register") || "Register account"}</span></button></p>}
        <p><button className="link agreement" onClick={() => window.location.href = `${AppConfig.NEWS_URL}/faq?client_id=${config.client_id}&return_url=${encodeURIComponent(getReturnToUrl())}`}><span>{"FAQ"}</span></button></p>
      </div>
      {addSocialItems}
    </div>
  );
}
